import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  // CarouselIndicators,
  CarouselCaption,
  // Container,
  Row,
  Col,
} from "reactstrap";

import img1 from "../../../assets/images/ui/img1.png";
import img2 from "../../../assets/images/ui/img2.png";
import img3 from "../../../assets/images/ui/img3.png";
import img4 from "../../../assets/images/ui/img4.png";

const items = [
  {
    src: img1,
    altText: "",
    caption: "",
  },
  {
    src: img2,
    altText: "",
    caption: "",
  },
  {
    src: img3,
    altText: "",
    caption: "",
  },
  {
    src: img4,
    altText: "",
    caption: "",
  },
];



const CsComponents = (props) => {

      const [activeIndex, setActiveIndex] = useState(0);
      const [animating, setAnimating] = useState(false);

       const next = () => {
         if (animating) return;
         const nextIndex =
           activeIndex === items.length - 1 ? 0 : activeIndex + 1;
         setActiveIndex(nextIndex);
       };

       const previous = () => {
         if (animating) return;
         const nextIndex =
           activeIndex === 0 ? items.length - 1 : activeIndex - 1;
         setActiveIndex(nextIndex);
       };

      //  const goToIndex = (newIndex) => {
      //    if (animating) return;
      //    setActiveIndex(newIndex);
      //  };

       const slides = items.map((item) => (
         <CarouselItem
           className="custom-tag"
           onExiting={() => setAnimating(true)}
           onExited={() => setAnimating(false)}
           key={item.src}
         >
           <img className="w-100" src={item.src} alt={item.altText} />
           <CarouselCaption
             captionText={item.caption}
             captionHeader={item.caption}
           />
         </CarouselItem>
       ));

    return (
      <div>
          <Row>
            <Col lg="12">
              <Carousel
                activeIndex={activeIndex}
                next={next.bind(null)}
                previous={previous.bind(null)}
              >
                {/* <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex.bind(null)}
                /> */}
                {slides}
                <CarouselControl
                  direction="prev"
                  directionText="Previous"
                  onClickHandler={previous.bind(null)}
                />
                <CarouselControl
                  direction="next"
                  directionText="Next"
                  onClickHandler={next.bind(null)}
                />
              </Carousel>
            </Col>
          </Row>

      </div>
    );
   
}

export default CsComponents;

